import script from "./AccommodationSection.vue?vue&type=script&setup=true&lang=js"
export * from "./AccommodationSection.vue?vue&type=script&setup=true&lang=js"

import "./AccommodationSection.vue?vue&type=style&index=0&id=358c45e1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-358c45e1"]])

export default __exports__